import React from 'react';
import { StyledPdfViewer } from 'styles/pages/staples-bulk-orders';

const PdfViewer = ({ state }) => {
  let splitValue = state?.artProofUrl?.split('.');
  if (splitValue?.length) {
    splitValue[splitValue?.length - 1] = 'pdf';
  }

  return (
    <StyledPdfViewer>
      <iframe src={state?.poPdfPath} />
      {splitValue?.length && <iframe src={splitValue?.join('.')} />}
    </StyledPdfViewer>
  );
};

export default PdfViewer;
